<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        style="width: 150px;"
        class="filter-item"
        placeholder="小程序名称"
        v-model="listQuery.title"
      ></el-input>
      <el-input
        style="width: 150px;"
        class="filter-item"
        placeholder="AppID"
        v-model="listQuery.appid"
      ></el-input>
      <el-select
        clearable
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.is_enable"
        placeholder="状态"
      >
        <el-option
          v-for="item in isEnableOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button
        class="filter-item"
        @click="$refs.edit.handleCreate()"
        type="primary"
        icon="el-icon-edit"
        v-permission="['base_services.add_miniprogram']"
      >添加</el-button>
    </div>

    <el-table
      :data="list"
      v-loading.body="listLoading"
      element-loading-text="加载中 ..."
      border
      highlight-current-row
    >
      <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
      <el-table-column label="ID" width="120" align="center" prop="number"></el-table-column>
      <el-table-column label="小程序名称" width="180" align="center" prop="title" show-overflow-tooltip></el-table-column>
      <el-table-column label="小程序类型" width="180" align="center" prop="mini_type_name" show-overflow-tooltip></el-table-column>
      <el-table-column label="AppID" width="200" align="center" prop="appid"></el-table-column>
      <el-table-column label="创建时间" width="200" align="center" prop="add_time"></el-table-column>
      <el-table-column label="排序" width="100" align="center" prop="order"></el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_enable"
            :active-value="1"
            :inactive-value="0"
            @change="handleEnable(scope.row.uuid, $event)"
            v-if="checkPermission(['base_services.change_miniprogram'])"
          ></el-switch>
          <span v-else>{{scope.row.is_enable ? '启用' : '禁用'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="150px"
        v-if="checkPermission(['base_services.change_miniprogram', 'base_services.delete_miniprogram'])"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="$refs.edit.handleEdit(scope.row.uuid)"
            v-permission="['base_services.change_miniprogram']"
          ></el-button>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-delete"
            @click="handleDel(scope.row.uuid)"
            v-if="scope.row.is_enable === 0"
            v-permission="['base_services.delete_miniprogram']"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>

    <edit ref="edit"></edit>
  </div>
</template>

<script>
import { getList, edit, del } from "@/api/exercise";
import Edit from "./components/Edit";

import checkPermission from "@/utils/permission";

export default {
  name: "exerciseIndex",
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        title: "",
        appid: "",
        is_enable: ""
      },
      isEnableOptions: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 }
      ]
    };
  },
  components: {
    Edit
  },
  created() {
    this.fetchData();
  },
  methods: {
    checkPermission,
    // 获取数据
    fetchData() {
      this.listLoading = true;
      getList(this.listQuery).then(res => {
        this.list = res.data.results;
        this.count = res.data.count;
        this.listLoading = false;
      });
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    // 启用、禁用
    handleEnable(uuid, value) {
      edit(uuid, {
        is_enable: value
      }).catch(() => {
        this.fetchData();
      });
    },
    // 删除
    handleDel(uuid) {
      this.$confirm("确认删除该项目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          del(uuid).then(() => {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
            this.fetchData();
          });
        })
        .catch(() => {});
    }
  }
};
</script>
